import React, { useState } from 'react';

const AddProcessTemplatePopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddProcessTemplatePopup, setShowAddProcessTemplatePopup] =
      useState<boolean>(false);

    const addToggleHandler = () => {
      setShowAddProcessTemplatePopup(!showAddProcessTemplatePopup);
    };

    return (
      <Component
        showAddProcessTemplatePopup={showAddProcessTemplatePopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AddProcessTemplatePopupHOC;
